import React from "react";

export default function MasterStatCard({ tone = "success", icon, value, label }) {
	const tones = {
		success: "bg-success/15",
		danger: "bg-danger/15",
		secondary: "bg-secondary/15",
		info: "bg-info/15",
		primary: "bg-primary/15",
	};
	const iconBg = {
		success: "bg-green-700",
		danger: "bg-danger",
		secondary: "bg-secondary",
		info: "bg-info",
		primary: "bg-primary",
	};

	return (
		<div className={`card overflow-hidden ${tones[tone] || tones.success}`}>
			<div className="card-body relative">
				<div className={`btn btn-icon size-12 ${iconBg[tone] || iconBg.success} text-white`}>
					{icon}
				</div>
				<h5 className="mb-2 mt-5 text-lg font-semibold text-default-900 dark:text-default-50">
					{value}
				</h5>
				<p className="m-0 text-sm text-default-700 dark:text-default-300">{label}</p>
			</div>
		</div>
	);
}
